export class BookingGridActionService {
    template: any;
    event: any;
    dataItem: any;
}